export enum EngagementHistoryRecordFeeDetailTypes {
    Summary = 0,
    PaymentInfo = 1,
    RefundInfo = 2,
}
